<template>
  <b-modal
    v-model="showModal"
    title="Cập nhật phiếu khiếu nại"
    size="lg"
    ok-title="Cập nhật"
    cancel-title="Hủy"
    @ok="handleOk"
    @hidden="resetForm"
    :ok-disabled="submitting"
    hide-backdrop
  >
    <b-form>
      <b-row>
        <b-col md="6">
          <b-form-group label="Lý do khiếu nại" label-for="complaintReasonId">
            <b-form-select
              id="complaintReasonId"
              class="select-style"
              v-model="form.complaintReasonId"
              :options="reasonOptions"
              value-field="id"
              text-field="name"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >Chọn lý do khiếu nại</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Trạng thái xử lý" label-for="processingStatusId">
            <b-form-select
              id="processingStatusId"
              class="select-style"
              v-model="form.processingStatusId"
              :options="statusOptions"
              value-field="id"
              text-field="name"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >Chọn trạng thái xử lý</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4">
          <b-form-group label="Đơn vị vận chuyển" label-for="shippingUnit">
            <b-form-input
              id="shippingUnit"
              v-model="form.shippingUnit"
              placeholder="VD: GHN, Viettel Post"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Số tiền bồi hoàn" label-for="compensationAmount">
            <BInputNumber
              id="compensationAmount"
              v-model="form.compensationAmount"
              size="sm"
              placeholder="VD: 500000"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Số tiền tổn thất" label-for="lossAmount">
            <BInputNumber
              id="lossAmount"
              v-model="form.lossAmount"
              size="sm"
              placeholder="VD: 100000"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group label="Đóng case" label-for="isClosed">
            <b-form-checkbox id="isClosed" v-model="form.isClosed">
              Đánh dấu đã đóng
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Ghi chú" label-for="notes">
            <b-form-textarea
              id="notes"
              v-model="form.notes"
              rows="3"
              placeholder="Nhập ghi chú"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
    <template #modal-footer>
      <b-button variant="secondary" @click="showModal = false">Hủy</b-button>
      <b-button variant="primary" @click="handleSubmit" :disabled="submitting">
        <b-spinner v-if="submitting" small></b-spinner>
        <span v-else>Cập nhật</span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { getToastInstance } from '@/utils/toastHelper';
import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue';

const shopeeAdminRepo = RepositoryFactory.get('shopeeAdmin');
const toast = getToastInstance();

export default {
  name: 'EditComplaintModal',
  components: { BInputNumber },
  data() {
    return {
      showModal: false,
      submitting: false,
      complaintId: null,
      reasons: [],
      statuses: [],
      form: {
        complaintReasonId: null,
        processingStatusId: null,
        shippingUnit: '',
        notes: '',
        isClosed: false,
        compensationAmount: null,
        lossAmount: null,
      },
    };
  },
  computed: {
    reasonOptions() {
      return this.reasons || [];
    },
    statusOptions() {
      return this.statuses || [];
    },
  },
  methods: {
    async open(item) {
      this.complaintId = item.id;
      this.form.complaintReasonId = item.complaintReasonId ?? null;
      this.form.processingStatusId = item.processingStatusId ?? null;
      this.form.shippingUnit = item.shippingUnit || '';
      this.form.notes = item.notes || '';
      this.form.isClosed = item.isClosed || false;
      this.form.compensationAmount = item.compensationAmount ?? null;
      this.form.lossAmount = item.lossAmount ?? null;

      await this.fetchReasons();
      await this.fetchStatuses();
      this.showModal = true;
    },
    async fetchReasons() {
      try {
        this.reasons = await shopeeAdminRepo.getComplaintReasons();
      } catch (e) {
        toast.makeToastFailure('Không tải được danh sách lý do khiếu nại');
        this.reasons = [];
      }
    },
    async fetchStatuses() {
      try {
        this.statuses = await shopeeAdminRepo.getComplaintStatuses();
      } catch (e) {
        toast.makeToastFailure('Không tải được danh sách trạng thái xử lý');
        this.statuses = [];
      }
    },
    resetForm() {
      this.complaintId = null;
      this.form = {
        complaintReasonId: null,
        processingStatusId: null,
        shippingUnit: '',
        notes: '',
        isClosed: false,
        compensationAmount: null,
        lossAmount: null,
      };
    },
    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.handleSubmit();
    },
    async handleSubmit() {
      try {
        this.submitting = true;
        await shopeeAdminRepo.updateComplaint(this.complaintId, {
          complaintReasonId: this.form.complaintReasonId
            ? Number(this.form.complaintReasonId)
            : undefined,
          processingStatusId: this.form.processingStatusId
            ? Number(this.form.processingStatusId)
            : undefined,
          shippingUnit: this.form.shippingUnit || undefined,
          notes: this.form.notes || undefined,
          isClosed: this.form.isClosed,
          compensationAmount:
            this.form.compensationAmount != null &&
            this.form.compensationAmount !== ''
              ? Number(this.form.compensationAmount)
              : null,
          lossAmount:
            this.form.lossAmount != null && this.form.lossAmount !== ''
              ? Number(this.form.lossAmount)
              : null,
        });
        toast.makeToastSuccess('Cập nhật phiếu khiếu nại thành công');
        this.showModal = false;
        this.$emit('updated');
      } catch (error) {
        const msg =
          error?.response?.data?.message || 'Không thể cập nhật phiếu khiếu nại';
        toast.makeToastFailure(msg);
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
